export default "__VITE_ASSET__Um1OyAPl__"